// extracted by mini-css-extract-plugin
export default {"wrapper":"qx-z","viewport":"rx-z","container":"sx-z","slide":"tx-z"};